<template>
  <section :class="$style.container">
    <article
      :class="$style.videoContainer"
      v-html="primary.embed_video && primary.embed_video.html"
    ></article>
  </section>
</template>

<script>
export default {
  name: 'TestimonialVideo',
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      primary: this.slice.primary,
      items: this.slice.items,
    }
  },
}
</script>

<style lang="scss" module>
.container {
  width: 694px;
  margin: 64px auto 90px;
  @include below(medium) {
    margin: 0 0 80px 0;
  }
}

.videoContainer {
  width: 100%;
  height: 100%;
  padding-top: 32px;
  iframe {
    width: 694px;
    height: 390px;
  }

  @include below(medium) {
    display: none;
  }
}
</style>
